export const SMALL_SCREEN = '(max-width: 600px)';
export const MEDIUM_SCREEN = '(max-width: 800px)';
